<template>
<div :class="['lnb-nav', 'dashboard-tree-container']">
  <div class="search">
    <w-search-field @search="filterTree"/>
  </div>
  <el-radio-group class="search tree-type-radio" style="margin-top:15px; width:100%;" v-if="coordDashboardEnable === true" v-model="activeTreeType">
    <el-radio-button style="width:50%;" :label="treeType.GRID_DASHBOARD"><span>기본 대시보드</span></el-radio-button>
    <el-radio-button style="width:50%;" :label="treeType.COORD_DASHBOARD"><span>커스텀 대시보드</span></el-radio-button>
  </el-radio-group>
  <article class="category-item">
    <div style="height:calc(100% - 50px); width:100%;" v-if="coordDashboardEnable === true">
      <div v-show="activeTreeType === treeType.GRID_DASHBOARD"  style="height:100%;">
        <el-scrollbar class="tree-wrapper">
          <w-dashboard-tree ref="gridDashboardTree" :tree-types="treeTypes" :dashboardType="DashboardConst.DASHBOARD_TYPE.GRID"></w-dashboard-tree>
        </el-scrollbar>
      </div>
      <div v-show="activeTreeType === treeType.COORD_DASHBOARD" style="height:100%;">
        <el-scrollbar class="tree-wrapper">
          <w-dashboard-tree ref="coordDashboardTree" :tree-types="treeTypes" :dashboardType="DashboardConst.DASHBOARD_TYPE.COORD"></w-dashboard-tree>
        </el-scrollbar>
      </div>
    </div>
    <el-scrollbar class="tree-wrapper" v-if="coordDashboardEnable === false">
      <w-dashboard-tree ref="gridDashboardTree" :tree-types="treeTypes" :dashboardType="DashboardConst.DASHBOARD_TYPE.GRID"></w-dashboard-tree>
    </el-scrollbar>
  </article>
</div>
</template>

<script>
import DashboardAPI from '@/api/dashboard/common';

import DashboardConst from '@/constants/dashboard';
import { treeType } from '@/constants/tree';
import isEmpty from 'lodash/isEmpty';
import WSearchField from '@/components/form/SearchField';
import WTreeSplitterTemplate from '@/components/template/TreeSplitterTemplate';
import WDashboardTree from '@/views/dashboard/components/frame/DashboardTree';

export default {
  name: 'WDashboardTreeContainer',
  components: {
    WSearchField,
    WTreeSplitterTemplate,
    WDashboardTree,
  },
  data() {
    return {
      treeType,
      DashboardConst,
      treeTypes: [treeType.GRID_DASHBOARD, treeType.COORD_DASHBOARD],
      activeTreeType: treeType.GRID_DASHBOARD,
      coordDashboardEnable: null,
    };
  },
  computed: {
  },
  created() {
    DashboardAPI.getCoordDashboardEnable().then((response) => {
      const result = response.data;

      if (result.success) {
        this.coordDashboardEnable = result.data;
      }
    });
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.ACTIVE_TREE_TYPE_SET, this.setActiveTreetype);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.ACTIVE_TREE_TYPE_SET, this.setActiveTreetype);
  },
  watch: {
  },
  methods: {
    setActiveTreetype(type) {
      if (!isEmpty(type)) {
        this.activeTreeType = `${type}_dashboard`;
      }
    },
    filterTree(value) {
      if (this.$refs.gridDashboardTree) {
        this.$refs.gridDashboardTree.filterTree(value);
      }

      if (this.$refs.coordDashboardTree) {
        this.$refs.coordDashboardTree.filterTree(value);
      }
    },
  },
};
</script>

<style lang="scss">
.dashboard-tree-container {
  // 트리 라디오 버튼 라벨 가운데 정렬하기 위해
  .el-radio-button--mini .el-radio-button__inner {
    padding: 7px 0px;
    letter-spacing: -1px;
  }
}
</style>

<style module>
.h100 {
  height: 100%;
}
.tree-title {
  color: #333;
  font-size: 17px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/frame/DashboardTreeContainer.vue